import moment from "moment";

export function getUtcNow() {
    return moment().utc().toDate();
}
